/**
 * Created by alvinoktavianus on 6/13/17.
 */

import React, { Component } from 'react'
import { Modal } from 'react-bootstrap'
import { currencyFormatter } from 'utils/formatter'

import styles from './PaymentGatewayErrorModal.css'

class PaymentGatewayErrorModal extends Component {
  render () {
    let {showModal, onHide, totalPrice} = this.props
    return (
      <Modal onHide={onHide} show={showModal} dialogClassName={`${styles['dialog']} ${styles['payment-error-modal-wrapper']} modal-dialog`}>
        <Modal.Body>
          <div className='payment-error-modal-wrapper'>
            <button type='button' className='close' onClick={onHide}>
              <span aria-hidden='true'>&times;</span>
            </button>
            <h4>PAYMENT</h4>
            <hr />
            <div className='row text-primary'>
              <div className='col-xs-7'>
                <h4>Total Payment</h4>
              </div>
              <div className='col-xs-5'>
                <h4 className='totalCount pull-right'>{currencyFormatter(totalPrice)}</h4>
              </div>
            </div>
            <div className={`row ${styles['mt-20px']}`}>
              <div className='col-md-12'>
                We are having a technical issue with our payment gateway. Please send the payment via bank transfer to
                address provided.
              </div>
            </div>
            <hr />
            <div className={`row ${styles['mt-20px']}`}>
              <div className='col-md-2'>
                <div className={styles['text-grey']}>Bank Name</div>
                <div className={styles['font-medium']}>BCA</div>
              </div>
              <div className='col-md-3'>
                <div className={styles['text-grey']}>Account Number</div>
                <div className={styles['font-medium']}>6560112538</div>
              </div>
              <div className='col-md-4'>
                <div className={styles['text-grey']}>Account Holder</div>
                <div className={styles['font-medium']}>PT Moka Teknologi Indonesia</div>
              </div>
              <div className='col-md-3'>
                <div className={styles['text-grey']}>Branch Name</div>
                <div className={styles['font-medium']}>Kebon Jeruk</div>
              </div>
            </div>
            <hr />
            <div className={`row ${styles['mt-20px']}`}>
              <div className={`col-md-12 ${styles['mb-20px']}`}>
                Confirm your payment with payment receipt to <a href='mailto:billing@mokapos.com'>billing@mokapos.com</a> so we can process your payment immediately (within office hour).
              </div>
            </div>
            <div className={`row ${styles['mb-20px']}`}>
              <div className='col-md-12'>
                <button
                  type='button'
                  className='btn btn-default btn-large btn-block'
                  onClick={onHide}>
                  <strong>Close</strong>
                </button>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    )
  }
}
export default PaymentGatewayErrorModal



// WEBPACK FOOTER //
// ./app/components/PaymentGatewayErrorModal/PaymentGatewayErrorModal.js